import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 22 22'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M10.25 4.212V.519h1.5v3.693zm6.073 2.519-1.029-1.029 2.579-2.663 1.063 1.078zm1.465 5.019v-1.5h3.693v1.5zm-7.538 9.73v-3.682h1.5v3.683zM5.696 6.69 3.04 4.127l1.088-1.054 2.614 2.604zm12.162 12.272-2.564-2.664 1.014-1.004 2.619 2.548zM.519 11.75v-1.5h3.693v1.5zm3.598 7.212-1.044-1.089 2.579-2.579.542.512.552.527zm6.885-2.462q-2.29 0-3.896-1.604T5.5 11.003t1.604-3.896Q8.708 5.5 10.998 5.5t3.896 1.604 1.606 3.894-1.604 3.896Q13.293 16.5 11.003 16.5M11 15q1.65 0 2.825-1.175T15 11t-1.175-2.825T11 7 8.175 8.175 7 11t1.175 2.825T11 15'
    />
  </svg>
)
export default SvgComponent
